import { render, staticRenderFns } from "./AddOwnContentToSAndL.vue?vue&type=template&id=62243e8d&"
import script from "./AddOwnContentToSAndL.vue?vue&type=script&lang=ts&"
export * from "./AddOwnContentToSAndL.vue?vue&type=script&lang=ts&"
import style0 from "./AddOwnContentToSAndL.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports